import { Injectable, inject } from '@angular/core';
import { BaseEntityRepository } from '../../core/abstractions/base-entity.repository';
import { DbContext } from '../../core/utils/db-context';
import { RepositoryService } from '../repository.service';
import { RepositoriesConfig } from '../../core/utils/repositories.config';
import { TemplateModel } from '../../models/template.model';

@Injectable({
    providedIn: 'root'
})
export class TemplatesRepository extends BaseEntityRepository<TemplateModel> {

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const repositoryService = inject(RepositoryService);

        super(repositoryService);
        this.config = RepositoriesConfig.repositories.find(
            r => r.tableName === DbContext.Templates
        );
    }
}
